
import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FAQKeyword from './FAQKeyword';
import Testimonialskeyword from './TestimonialKeyword';

function Punetonavimumbaiairportonewaycab() {



const cardData = {
  keyword: "Pune to Navi Mumbai Airport One Way Cab",
  heading: "Skyline Cabs: Pune to Navi Mumbai Airport One Way Cab",
  headingDescription: "Skyline Cabs provides reliable and professionally managed Pune to Navi Mumbai Airport One Way Cab services for corporate travelers, IT professionals, families, and long-distance airport passengers. Whether you are traveling from central Pune, Kharadi, Baner, Hadapsar, or Pimpri-Chinchwad, we ensure smooth expressway connectivity to Navi Mumbai International Airport. Our fleet includes well-maintained AC sedans, SUVs, and premium vehicles suitable for luggage-friendly long-distance travel. With experienced chauffeurs, punctual pickup scheduling, transparent fare structure, and 24x7 availability, Skyline Cabs ensures safe, comfortable, and stress-free one-way airport transfers from Pune to Navi Mumbai.",

  top: "Top Places to visit in Navi Mumbai with skyline Cab",

 topPlaces: [
  {
    title: "Palm Beach Road",
    description: "Palm Beach Road is one of the most scenic stretches in Navi Mumbai offering wide lanes, sea views, and smooth connectivity between Vashi, Nerul, and Belapur. Travelers heading toward Chhatrapati Shivaji Maharaj International Airport or Navi Mumbai International Airport enjoy this peaceful coastal drive. The well-planned infrastructure and skyline views make it ideal for business and residential access."
  },
  {
    title: "Central Park Kharghar",
    description: "Central Park in Kharghar is one of the largest urban parks in India, offering jogging tracks, musical fountains, gardens, and open green spaces. It is a perfect relaxation spot for families and professionals looking to unwind after travel or work commitments."
  },
  {
    title: "Pandavkada Waterfalls",
    description: "Pandavkada Waterfalls in Kharghar is a popular monsoon attraction known for its natural beauty and serene surroundings. Visitors from across Mumbai and nearby areas come here for short weekend trips and scenic photography."
  },
  {
    title: "Seawoods Grand Central Mall",
    description: "Seawoods Grand Central Mall is a premium shopping and entertainment destination featuring international brands, fine dining restaurants, and multiplex cinemas. Its proximity to major railway stations and business hubs makes it a convenient stop for travelers."
  },
  {
    title: "Nerul Balaji Temple",
    description: "Nerul Balaji Temple is a beautifully designed hilltop temple inspired by the Tirupati Balaji Temple. It offers peaceful surroundings, impressive architecture, and panoramic city views, attracting devotees and tourists alike."
  },
  {
    title: "Belapur Fort",
    description: "Belapur Fort is a historic structure built during the 16th century, offering trekking trails and scenic views of the surrounding creek areas. It is a favorite destination for history enthusiasts and adventure seekers."
  },
  {
    title: "DY Patil Stadium",
    description: "DY Patil Stadium in Nerul is a world-class sports venue that hosts IPL matches, concerts, and major events. Its modern infrastructure makes it one of the prominent landmarks in Navi Mumbai."
  },
  {
    title: "Kharghar Hills",
    description: "Kharghar Hills is a popular trekking and sunrise viewpoint destination offering panoramic views of Navi Mumbai. Nature lovers and fitness enthusiasts frequently visit for early morning hikes."
  },
  {
    title: "Wonders Park Nerul",
    description: "Wonders Park in Nerul is a family-friendly attraction featuring miniature replicas of the Seven Wonders of the World along with landscaped gardens and play areas for children."
  },
  {
    title: "Vashi Creek",
    description: "Vashi Creek is known for its beautiful sunset views and peaceful waterfront atmosphere. It serves as a scenic gateway connecting Mumbai and Navi Mumbai, attracting photographers and evening walkers."
  }
],

services: [
  {
    name: "Pune to Navi Mumbai Airport One Way Cab",
    description: "Skyline Cabs offers professional Pune to Navi Mumbai Airport One Way Cab service designed for economical and punctual airport transfers without return fare charges. Our fleet includes well-maintained, air-conditioned sedans and SUVs suitable for long expressway travel with sufficient luggage capacity. Experienced chauffeurs monitor traffic conditions across Pune city and expressway corridors to ensure timely airport arrival. We carefully coordinate departure timing based on flight schedules to prevent last-minute delays. Transparent fixed pricing, structured booking confirmation, and disciplined highway driving standards ensure reliable one-way airport connectivity."
  },
  {
    name: "Pune to Navi Mumbai Airport One Way Taxi",
    description: "Pune to Navi Mumbai Airport One Way Taxi service ensures smooth intercity airport transfers supported by professional chauffeur management. Vehicles are sanitized, comfortable, and optimized for long-distance highway performance with adequate baggage space. Drivers plan pickups from residential and commercial zones across Pune while monitoring peak-hour congestion. We align travel timing with airport reporting schedules for punctual drop-offs. Clear fare breakdown, structured coordination, and safe driving practices guarantee dependable one-way taxi solutions."
  },
  {
    name: "Pune to Navi Mumbai Airport One Way Cabs",
    description: "Pune to Navi Mumbai Airport One Way Cabs service provides multiple vehicle options including sedan, SUV, and premium categories for comfortable airport transfers. Skyline Cabs ensures vehicles undergo regular maintenance checks for smooth expressway travel. Professional drivers monitor traffic flow and select optimized routes for timely airport arrival. Departure scheduling is carefully planned to align with flight timings. Transparent billing structure and consistent service standards deliver reliable one-way airport cab experiences."
  },
  {
    name: "Pune to Navi Mumbai Airport One Way Drop",
    description: "Pune to Navi Mumbai Airport One Way Drop service is structured for efficient airport connectivity with fixed and transparent pricing. Skyline Cabs ensures punctual pickup from any Pune locality with professional chauffeur coordination. Vehicles are air-conditioned and designed for comfortable long-distance travel with sufficient luggage space. Drivers monitor highway traffic conditions and adjust routing for smooth transit. Clear billing policies and disciplined travel management ensure dependable drop services."
  },
  {
    name: "One Way Cab Pune to Navi Mumbai Airport",
    description: "One Way Cab Pune to Navi Mumbai Airport service delivers economical airport transportation supported by experienced long-route drivers. Skyline Cabs provides well-maintained vehicles optimized for expressway connectivity and passenger comfort. Departure timing is strategically managed considering city traffic and airport reporting schedules. We ensure smooth routing through highway corridors for uninterrupted travel. Transparent pricing and professional coordination guarantee stress-free one-way transfers."
  },
  {
    name: "Hadapsar to Navi Mumbai Airport One Way Cab",
    description: "Hadapsar to Navi Mumbai Airport One Way Cab service ensures reliable airport connectivity with structured pickup coordination from residential and commercial areas. Skyline Cabs offers comfortable vehicles designed for smooth highway travel with adequate luggage accommodation. Drivers monitor traffic patterns around Hadapsar to manage timely departures. We align airport arrival timing with flight schedules to prevent delays. Transparent fixed pricing and disciplined service standards ensure dependable one-way airport transfers."
  },
  {
    name: "Hinjewadi to Navi Mumbai Airport One Way Taxi",
    description: "Hinjewadi to Navi Mumbai Airport One Way Taxi service provides punctual airport transfers tailored for IT professionals and corporate travelers. Skyline Cabs ensures timely pickup from Hinjewadi phases with optimized expressway routing. Vehicles are sanitized and maintained for smooth long-distance travel performance. Drivers carefully coordinate departure timing based on highway traffic conditions. Transparent fare policies and structured booking management deliver reliable one-way taxi services."
  },
  {
    name: "Wakad to Navi Mumbai Airport One Way Cab",
    description: "Wakad to Navi Mumbai Airport One Way Cab service delivers dependable airport connectivity with professional chauffeur support. Skyline Cabs coordinates punctual pickup from Wakad residential and business hubs with optimized routing. Vehicles are air-conditioned and suitable for long expressway journeys with sufficient luggage space. Traffic monitoring ensures efficient departure scheduling and timely airport drop-offs. Transparent billing and safety-focused management guarantee consistent one-way cab service."
  },
  {
    name: "Kharadi to Navi Mumbai Airport One Way Taxi",
    description: "Kharadi to Navi Mumbai Airport One Way Taxi service ensures smooth airport travel with structured pickup coordination and highway expertise. Skyline Cabs provides comfortable vehicles optimized for long-distance intercity connectivity. Drivers monitor traffic updates near Kharadi IT parks and adjust departure timing accordingly. We align airport arrival schedules with flight timings for punctual drop service. Transparent pricing and disciplined driving standards ensure dependable taxi transfers."
  },
  {
    name: "Baner to Navi Mumbai Airport One Way Cab",
    description: "Baner to Navi Mumbai Airport One Way Cab service offers reliable airport transfers supported by experienced drivers and optimized route planning. Skyline Cabs ensures clean, comfortable vehicles suitable for smooth expressway travel with adequate baggage space. Departure timing is carefully managed to avoid congestion across Baner and expressway entry points. We maintain punctual arrival coordination aligned with airport reporting schedules. Transparent fare structure and consistent service standards ensure dependable connectivity."
  },
  {
    name: "Pimpri Chinchwad to Navi Mumbai Airport One Way Cab",
    description: "Pimpri Chinchwad to Navi Mumbai Airport One Way Cab service provides secure and punctual airport transfers with structured pickup coordination. Skyline Cabs offers well-maintained vehicles optimized for long-distance highway travel comfort. Drivers plan departure timing considering PCMC traffic patterns and expressway flow. We ensure smooth routing and timely airport drop-offs aligned with flight schedules. Transparent fixed pricing and disciplined service execution guarantee reliable one-way connectivity."
  },
  {
    name: "Innova Crysta Pune to Navi Mumbai Airport One Way",
    description: "Innova Crysta Pune to Navi Mumbai Airport One Way service offers premium and spacious airport transfers ideal for families and corporate executives. The vehicle provides enhanced seating comfort, larger luggage capacity, and stable expressway performance. Professional chauffeurs coordinate timely departure and optimized routing for punctual arrival. We align travel schedules with airport reporting time to prevent delays. Transparent pricing and structured booking confirmation ensure premium one-way service quality."
  },
  {
    name: "Ertiga Cab Pune to Navi Mumbai Airport One Way",
    description: "Ertiga Cab Pune to Navi Mumbai Airport One Way service delivers economical yet comfortable airport connectivity for small groups and business travelers. The vehicle ensures balanced seating comfort and sufficient baggage space for smooth highway transit. Drivers monitor traffic conditions and manage departure timing strategically. Airport arrival schedules are aligned with flight timings for punctual drop-offs. Clear pricing structure and professional service standards ensure dependable one-way travel."
  },
  {
    name: "Sedan Cab Pune to Navi Mumbai Airport One Way",
    description: "Sedan Cab Pune to Navi Mumbai Airport One Way service provides cost-effective and reliable airport transportation with comfortable air-conditioned seating. Skyline Cabs ensures timely pickup from Pune localities with optimized highway routing. Drivers carefully coordinate departure timing to maintain punctual airport arrival. Vehicles are maintained for efficient long-distance performance and smooth transit. Transparent billing and disciplined service standards guarantee consistent one-way taxi quality."
  },
  {
    name: "SUV Cab Pune to Navi Mumbai Airport One Way",
    description: "SUV Cab Pune to Navi Mumbai Airport One Way service offers spacious and comfortable airport transfers ideal for families and group passengers. Vehicles provide higher seating comfort, increased luggage capacity, and stable expressway performance. Professional chauffeurs monitor traffic updates and adjust routing for efficient travel. Departure scheduling is aligned with airport reporting time for punctual arrival. Transparent pricing and safety-focused management ensure reliable one-way SUV connectivity."
  },
  {
    name: "Pune to Navi Mumbai Airport One Way Cab Booking",
    description: "Pune to Navi Mumbai Airport One Way Cab Booking service provides convenient advance reservation with structured confirmation and vehicle allocation support. Skyline Cabs ensures availability of sedan, SUV, and premium categories for airport travel needs. Drivers maintain punctual pickup and optimized expressway routing. Departure timing is carefully aligned with airport reporting schedules. Transparent fare policies and professional coordination ensure stress-free booking experiences."
  },
  {
    name: "Pune to Navi Mumbai Airport One Way Taxi Service",
    description: "Pune to Navi Mumbai Airport One Way Taxi Service ensures dependable airport transfers supported by professional chauffeur coordination and comfortable vehicles. Skyline Cabs provides structured pickup scheduling from residential and corporate areas across Pune. Drivers monitor highway traffic flow and adjust routing for smooth transit. We maintain punctual airport arrival timing aligned with flight schedules. Transparent pricing structure and disciplined service management guarantee consistent and reliable one-way taxi connectivity."
  }
],

tableData: [
  ["Pune to Navi Mumbai Airport One Way Cab", "Pune to Navi Mumbai Airport One Way Taxi"],
  ["Pune to Navi Mumbai Airport One Way Cabs", "Pune to Navi Mumbai Airport One Way Drop"],
  ["One Way Cab Pune to Navi Mumbai Airport", "Hadapsar to Navi Mumbai Airport One Way Cab"],
  ["Hinjewadi to Navi Mumbai Airport One Way Taxi", "Wakad to Navi Mumbai Airport One Way Cab"],
  ["Kharadi to Navi Mumbai Airport One Way Taxi", "Baner to Navi Mumbai Airport One Way Cab"],
  ["Pimpri Chinchwad to Navi Mumbai Airport One Way Cab", "Innova Crysta Pune to Navi Mumbai Airport One Way"],
  ["Ertiga Cab Pune to Navi Mumbai Airport One Way", "Sedan Cab Pune to Navi Mumbai Airport One Way"],
  ["SUV Cab Pune to Navi Mumbai Airport One Way", "Pune to Navi Mumbai Airport One Way Cab Booking"],
  ["Pune to Navi Mumbai Airport One Way Taxi Service", ""]
],

whychoose: [
  {
    WhyChooseheading: "Expert Pune Pickup for Airport Transfers",
    WhyChoosedescription: "Skyline Cab drivers have thorough knowledge of Pune’s major roads, traffic bottlenecks, and key pickup points including Koregaon Park, Kalyani Nagar, and Swargate. This expertise ensures quick and hassle-free pickup for your one-way journey to Navi Mumbai Airport. We monitor real-time traffic conditions, select the fastest routes, and plan your departure to guarantee timely airport arrival, making your airport transfer smooth and stress-free."
  },
  {
    WhyChooseheading: "Highway and Expressway Mastery",
    WhyChoosedescription: "Our chauffeurs are highly experienced with long-distance travel, especially on the Pune–Mumbai Expressway. They maintain safe speeds, handle highway conditions expertly, and navigate toll plazas efficiently. With familiarity in expressway traffic patterns and alternative routes, Skyline Cab ensures your one-way transfer from Pune to Navi Mumbai Airport is comfortable, punctual, and secure, regardless of peak travel times."
  },
  {
    WhyChooseheading: "Punctual One-Way Airport Guarantee",
    WhyChoosedescription: "Skyline Cab emphasizes punctuality for one-way airport transfers, ensuring you reach Navi Mumbai Airport well in advance of flight departure. We plan pickup times considering train or flight schedules, city traffic, and travel distance to avoid last-minute stress. Our structured approach guarantees a timely, reliable, and hassle-free journey for domestic and international flights alike."
  },
  {
    WhyChooseheading: "Transparent One-Way Fare Structure",
    WhyChoosedescription: "We provide a clear, upfront fare for Pune to Navi Mumbai Airport one-way trips, including all toll charges, driver allowances, and taxes. There are no hidden costs, allowing passengers to plan their budget with confidence. Skyline Cab’s transparent pricing policy ensures you get premium service at fair rates without surprises."
  },
  {
    WhyChooseheading: "24/7 Availability for Airport Transfers",
    WhyChoosedescription: "Skyline Cab operates round-the-clock, catering to flights at any hour—early morning, late night, or mid-day. Our 24/7 customer support coordinates bookings, driver assignments, and live updates to ensure your one-way transfer from Pune to Navi Mumbai Airport is always ready and dependable, even during last-minute travel changes."
  },
  {
    WhyChooseheading: "Comfortable and Hygienic AC Vehicles",
    WhyChoosedescription: "Our fleet of air-conditioned vehicles is designed for long-distance travel, with spacious seating and ample luggage capacity. All vehicles are regularly sanitized and maintained to high standards, providing a safe and comfortable ride for individuals, families, and corporate travelers taking one-way trips to Navi Mumbai Airport."
  },
  {
    WhyChooseheading: "Ideal for Corporate and Leisure Travelers",
    WhyChoosedescription: "Skyline Cab caters to both business and personal passengers. Executives traveling to flights can enjoy quiet, professional service, while families or solo travelers benefit from courteous drivers, luggage assistance, and a smooth ride experience. Our one-way airport transfer service combines convenience, reliability, and comfort for all types of travelers."
  },
  {
    WhyChooseheading: "Dedicated Customer Support and Trip Coordination",
    WhyChoosedescription: "From the moment you book until you reach Navi Mumbai Airport, our customer support team provides active assistance, including real-time driver tracking, updates, and responsive solutions for any changes. Skyline Cab ensures a seamless, stress-free one-way transfer experience, focusing on safety, reliability, and total passenger satisfaction."
  }
]


}

const faqData = [
    {
        id: 1,
        question: 'How can I book Pune to Navi Mumbai Airport One Way Cab with Skyline Cabs?',
        answer:
            'Booking Pune to Navi Mumbai Airport One Way Cab with Skyline Cabs is quick and completely hassle-free. You simply need to visit our website or mobile app, enter Pune as your pickup location and Navi Mumbai Airport as your drop destination, choose the one-way option, select your preferred vehicle, and confirm instantly. You will receive immediate booking confirmation along with complete driver and vehicle details. Our smooth booking process ensures reliable airport travel without last-minute stress.',
    },
    {
        id: 2,
        question: 'Is Pune to Navi Mumbai Airport One Way Cab service available 24/7?',
        answer:
            'Yes, Skyline Cabs provides 24/7 Pune to Navi Mumbai Airport One Way Cab service for both early morning and late-night flights. Whether you are traveling from Baner, Hinjewadi, Hadapsar, Kothrud, or any part of Pune, our drivers ensure punctual pickup and timely airport drop. We understand flight timings are critical and prioritize on-time service for every airport transfer.',
    },
    {
        id: 3,
        question: 'What vehicle options are available for Pune to Navi Mumbai Airport One Way Cab?',
        answer:
            'We offer multiple vehicle options including Swift Dzire, Ertiga, Innova Crysta, and premium SUVs for Pune to Navi Mumbai Airport One Way Cab bookings. You can choose a budget-friendly sedan for economical travel or spacious SUVs for family and group airport transfers. All vehicles are well-maintained, fully air-conditioned, and driven by experienced professional chauffeurs.',
    },
    {
        id: 4,
        question: 'How much is the Pune to Navi Mumbai Airport One Way Cab fare?',
        answer:
            'The Pune to Navi Mumbai Airport One Way Cab fare depends on the vehicle type and travel date. Skyline Cabs follows a transparent pricing model where the total fare is displayed before booking confirmation. The price includes driver allowance and applicable charges, ensuring no hidden costs or surprise payments at the end of your journey.',
    },
    {
        id: 5,
        question: 'What are the benefits of choosing a One Way Cab from Pune to Navi Mumbai Airport?',
        answer:
            'Choosing Pune to Navi Mumbai Airport One Way Cab helps you avoid unnecessary return fare charges. You pay only for the distance traveled, making it cost-effective and convenient. It is ideal for business travelers, families, and individuals who need a direct airport transfer without booking a round trip. The one-way option ensures flexibility and budget control.',
    },
    {
        id: 6,
        question: 'How long does it take to travel from Pune to Navi Mumbai Airport by cab?',
        answer:
            'The journey from Pune to Navi Mumbai Airport typically takes around 2.5 to 3.5 hours depending on traffic conditions and time of travel. Our experienced drivers use the best highway routes and expressways to ensure smooth, safe, and comfortable long-distance travel.',
    },
    {
        id: 7,
        question: 'Is online payment available for Pune to Navi Mumbai Airport One Way Cab booking?',
        answer:
            'Yes, Skyline Cabs supports secure online payment options including UPI, credit cards, debit cards, and net banking. Once your payment is completed successfully, you receive instant booking confirmation along with complete trip and driver details for peace of mind.',
    },
    {
        id: 8,
        question: 'Can I pre-book Pune to Navi Mumbai Airport One Way Cab in advance?',
        answer:
            'Absolutely. You can pre-book your Pune to Navi Mumbai Airport One Way Cab for any future date and time. Advance booking ensures vehicle availability, especially during peak travel seasons, weekends, and corporate travel rush hours.',
    },
    {
        id: 9,
        question: 'Is Pune to Navi Mumbai Airport One Way Cab suitable for corporate travel?',
        answer:
            'Yes, our Pune to Navi Mumbai Airport One Way Cab service is highly preferred by corporate professionals and business travelers. We provide punctual pickups, professional chauffeurs, clean vehicles, and reliable service for executive airport transfers.',
    },
    {
        id: 10,
        question: 'Why choose Skyline Cabs for Pune to Navi Mumbai Airport One Way Cab?',
        answer:
            'Skyline Cabs is trusted for Pune to Navi Mumbai Airport One Way Cab service because of our transparent pricing, professional drivers, sanitized vehicles, punctual airport transfers, and 24x7 customer support. We focus on delivering safe, reliable, and comfortable one-way airport travel every time.',
    },
];

const someReviews = [
    {
        name: "Mr. Aniket Patil",
        rating: 5,
        review: "Booked Pune to Navi Mumbai Airport One Way Cab with Skyline Cabs for my business flight. The driver arrived on time, vehicle was clean, and the journey was smooth and comfortable. Highly dependable airport service!"
    },
    {
        name: "Mrs. Shreya Kulkarni",
        rating: 4,
        review: "Very reliable Pune to Navi Mumbai Airport One Way Cab service. Transparent pricing and comfortable ride made our airport transfer stress-free. Skyline Cabs provides professional and punctual service."
    },
];
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    



    const contactData = {
        heading: `${cardData.keyword} Contact Number`,
        contactNumbers: [
            "+91 7620911746",


        ],
        email: "booking@skylinecabs.com"
    };


    const Images = [
        {
            place: "/images/keyword/1.jpg",
            text: "Pune to Mumbai Cab",
        },
        {
            place: "/images/keyword/2.jpg",
            text: "Pune to Mumbai Airport Cab",
        },
        {
            place: "/images/keyword/3.jpg",
            text: "Pune to Mumbai International Airport Cab",
        },
        {
            place: "/images/keyword/4.jpg",
            text: "Pune to Mumbai One Way Cab",
        },
        {
            place: "/images/keyword/5.jpg",
            text: "Pune Mumbai Car Hire",
        },
        {
            place: "/images/keyword/6.jpg",
            text: "  Pune to Mumbai Taxi Fare ",
        },
        {
            place: "/images/keyword/7.jpg",
            text: "Pune to Mumbai Online Cab Booking",
        },

        {
            place: "/images/keyword/8.jpg",
            text: " Pimpri Chinchwad to Mumbai Cab",
        },

        {
            place: "/images/keyword/9.jpg",
            text: "Baner to Mumbai Cabs",
        },
        {
            place: "/images/keyword/10.jpg",
            text: "Hinjewadi to Mumbai Cab",
        },

        {
            place: "/images/keyword/11.jpg",
            text: "Pimple Saudagar to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/12.jpg",
            text: "Wakad to Mumbai Cab",
        },

        {
            place: "/images/keyword/13.jpg",
            text: "Hadapsar to Mumbai Cab",
        },

        {
            place: "/images/keyword/14.jpg",
            text: "Kalyani Nagar to Mumbai Taxi",
        },
        {
            place: "/images/keyword/15.jpg",
            text: "Koregaon Park to Mumbai Cab",
        },
        {
            place: "/images/keyword/16.jpg",
            text: " Kothrud to Mumbai Cab",
        },
        {
            place: "/images/keyword/17.jpg",
            text: "Kharadi to Mumbai Cab",
        },
        {
            place: "/images/keyword/18.jpg",
            text: "Shivajinagar to Mumbai Cab",
        },
        {
            place: "/images/keyword/19.jpg",
            text: "Pune to Mumbai Ertiga Cab",
        },
        {
            place: "/images/keyword/20.jpg",
            text: " Pune to Mumbai Innova Crysta Cab",
        },
        {
            place: "/images/keyword/21.jpg",
            text: " Pune to Mumbai Sedan Cab",
        },
        {
            place: "/images/keyword/22.jpg",
            text: "Kondhwa to Mumbai Cab",
        },
        {
            place: "/images/keyword/23.jpg",
            text: "Viman Nagar to Mumbai Cabs",
        },
        {
            place: "/images/keyword/24.jpg",
            text: "Katraj to Mumbai Cab Service",
        },
        {
            place: "/images/keyword/25.jpg",
            text: " Pune Station to Mumbai Cabs Service",
        },
        {
            place: "/images/keyword/26.jpg",
            text: "Boat Club Road to Mumbai Cab ",
        },
        {
            place: "/images/keyword/27.jpg",
            text: " Vishrantwadi to Mumbai Cab",
        },
    ];


    const images = [
        { src: "/images/ourfleet/1.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/5.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/2.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/3.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/4.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/7.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/8.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/9.jpg", alt: "Image 1" },
        { src: "/images/ourfleet/6.jpg", alt: "Image 1" },

    ];



      
    
      const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Navi Mumbai Airport One Way Cab",
  "image": "https://skylinecabs.com/assets/images/pune-to-navi-mumbai-airport-one-way-cab.jpg",
  "description": "Book Pune to Navi Mumbai Airport One Way Cab with Skyline Cabs for safe, comfortable, and timely airport transfers. AC, Innova Crysta, Ertiga, and Sedan cabs available from Hadapsar, Hinjewadi, Wakad, Kharadi, Baner, and Pimpri Chinchwad with professional drivers at affordable fares.",
  "brand": {
    "@type": "Brand",
    "name": "Skyline Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "8043"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2599",
    "availability": "https://schema.org/InStock",
    "url": "https://skylinecabs.com/pune-to-navi-mumbai-airport-one-way-cab"
  }
};




    return (
        <div>

<Helmet>
  <title>Pune to Navi Mumbai Airport One Way Cab | AC Pickup & Drop | Skyline Cabs</title>
  <meta 
    name="description" 
    content="Book Pune to Navi Mumbai Airport One Way Cab with Skyline Cabs for safe, comfortable, and timely airport transfers. AC, Innova Crysta, Ertiga, and Sedan cabs available from Hadapsar, Hinjewadi, Wakad, Kharadi, Baner, and Pimpri Chinchwad." 
  />
  <meta 
    name="keywords" 
    content="Pune to Navi Mumbai Airport One Way Cab, Pune to Navi Mumbai Airport One Way Taxi, Pune to Navi Mumbai Airport One Way Cabs, Pune to Navi Mumbai Airport One Way Drop, One Way Cab Pune to Navi Mumbai Airport, Hadapsar to Navi Mumbai Airport One Way Cab, Hinjewadi to Navi Mumbai Airport One Way Taxi, Wakad to Navi Mumbai Airport One Way Cab, Kharadi to Navi Mumbai Airport One Way Taxi, Baner to Navi Mumbai Airport One Way Cab, Pimpri Chinchwad to Navi Mumbai Airport One Way Cab, Innova Crysta Pune to Navi Mumbai Airport One Way, Ertiga Cab Pune to Navi Mumbai Airport One Way, Skyline Cabs Pune to Navi Mumbai Airport One Way" 
  />
  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      
            <section
                className="bg-cover position-relative"
                style={{
                    background: 'url(/img/bg-title.jpg) no-repeat',
                }}
                data-overlay="5"
            >
                <div className="container">
                    <div className="row align-items-center justify-content-center">
                        <div className="col-xl-7 col-lg-9 col-md-12">
                            <div className="fpc-capstion text-center my-4">
                                <div className="fpc-captions">
                                    <h1 className="xl-heading text-light">{cardData.keyword}</h1>

                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>


            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 ">
                            <img src='/images/keyword/141.jpg' alt='img' className='img-fluid'/>
                            <h3 className="py-1"
                                style={{
                                    color: '#F26722', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="">
                                <p className='fw-bold py-3 darkcolor'>{cardData.top}</p>
                                {cardData.topPlaces.map((place, index) => (
                                    <div key={index} className="">
                                        <div
                                            style={{
                                                cursor: 'pointer',
                                                padding: '10px',
                                                marginBottom: '7px',
                                                borderRadius: '8px',
                                                transition: 'transform 0.2s'
                                            }}

                                        >
                                            <h4 className="mb-1 darkcolor">{place.title}</h4>
                                            <p className="mb-0">{place.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    marginBottom: '7px',
                                    borderRadius: '8px', // Optional: rounded corners
                                    transition: 'transform 0.2s' // Optional: smooth scaling effect
                                }}
                            >
                                {cardData.services.map((service, index) => (
                                    <div key={index} className=" my-4">
                                        <h4 className="py-1 darkcolor">{service.name}</h4>
                                        <p>{service.description}</p>
                                    </div>
                                ))}
                            </div>

                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section"
                                className='px-2'>
                                {cardData.whychoose.map((item, index) => (
                                    <div key={index}>
                                        <h4 className="py-1 whycolor">{item.WhyChooseheading}</h4>
                                        <p>{item.WhyChoosedescription}</p>
                                    </div>
                                ))}
                            </div>


                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Skyline Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">


                                                <FAQKeyword faqData={faqData} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <Testimonialskeyword reviews={someReviews} />

                            <div className='py-4'>

                                <div className="contact-box Borderr">
                                    <h3>{contactData.heading}</h3>
                                    <p className='text-black'>For booking inquiries or any assistance, please feel free to contact us:</p>
                                    <div className="contact-details">
                                        <p><strong className='darkcolor'>Mobile No:</strong></p>
                                        <ul>
                                            {contactData.contactNumbers.map((number, index) => (
                                                <li key={index}>
                                                    <a href={`tel:${number}`} className="contact-link fw-bold fs-5">
                                                        {number}
                                                    </a>
                                                </li>
                                            ))}
                                        </ul>
                                        <p><strong className='darkcolor'>Email Id: </strong>
                                            <a href={`mailto:${contactData.email}`} className="contact-link">
                                                {contactData.email}
                                            </a>
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div className='col-12 col-md-4' >
                            {Images.map((e) => {
                                return (
                                    <div className="box1">
                                        <a
                                            href="./"
                                            className="d-flex justify-content-around align-items-center"
                                        >
                                            <div className="b1">
                                                <img src={e.place} alt="img" />
                                            </div>
                                            <div className="b2">
                                                {" "}
                                                <a href="./" className='px-3'>{e.text}</a>
                                            </div>
                                        </a>
                                    </div>
                                );
                            })}


                            {/* <div className="gallery-container">
                                <h2 className="gallery-title">Our Fleets</h2>
                                <div className="gallery-row d-flex flex-wrap">
                                    {images.map((image, index) => (
                                        <div className="gallery-item col-md-4" key={index}>
                                            <img
                                                src={image.src}
                                                alt={image.alt}
                                                className="gallery-image"

                                            />
                                        </div>
                                    ))}

                                </div>
                            </div> */}

                            <div className=" rounded p-4 shadow-sm Uni_border "
                                style={{
                                    cursor: 'pointer',
                                    padding: '10px',
                                    border: '3px dotted #F26722',
                                    marginBottom: '7px',
                                    fontWeight: 'bold',
                                }}

                            >
                                <h4 className="pb-3 pt-3 lead fw-bold text-dark">Contact Information</h4>

                                <div className="row">

                                    <div className="col-12 mb-3">
                                        <div className="Small_border  rounded text-center py-2 " style={{ backgroundColor: '#F26722' }}>
                                            <h4 className=" lead fw-semibold whitt text-dark">Phone Numbers</h4>
                                            <div className=''>
                                                <a href="tel:+91 7620911746" className="d-block  text-white">+91 7620911746</a>


                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Email</h4>
                                                <a href="mailto:booking@skylinecabs.com" className=" text-white d-block">
                                                    booking@skylinecabs.com
                                                </a>
                                            </div>
                                        </div>
                                    </div>


                                    <div className="col-12 mb-3 ">
                                        <div className="Small_border  rounded text-center">
                                            <div className='rounded py-2' style={{ backgroundColor: '#F26722' }}>
                                                <h4 className=" fw-semibold lead whitt text-dark">Address</h4>
                                                <p className="whit text-white ">
                                                    <i> Skyline Cab<br />
                                                        Satya Nagar, 90 feet rd Saki Naka, Mumbai, Andheri Maharashtra 400072

                                                    </i>
                                                </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>



                        </div>
                    </div>
                </div>
            </section>



        </div>
    );
}

export default Punetonavimumbaiairportonewaycab;